import { ProjectAction } from "../types/project"
import { Dispatch } from "react"
import { ProjectActionType } from "../types/project"
import projectApi from "../../api/projectApi"

function getProjects() {
  return async (dispatch: Dispatch<ProjectAction>) => {
    try {
      dispatch({ type: ProjectActionType.FETCH_PROJECTS })
      const response = await projectApi.getProjects()
      dispatch({ type: ProjectActionType.FETCH_PROJECTS_SUCCESS, payload: response })
    } catch (error) {
      dispatch({ type: ProjectActionType.FETCH_PROJECTS_ERROR, payload: "Error loading projects" })
    }
  }
}

export default {
  getProjects,
}
